module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.4536",
      "hs-test-utils": "static-1.7096",
      "I18n": "static-7.1412",
      "jasmine-runner": "static-1.5516",
      "quartz": "static-1.5858",
      "hubspot-url-utils": "static-1.3383",
      "outpost": "static-1.3448",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.151",
      "moment": "static-3.26",
      "foundations-components": "static-1.6469",
      "framer-motion": "static-1.44",
      "hs-test-utils-bend-plugin": "static-1.2207",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.126",
      "enviro": "static-4.319",
      "i18n-data": "static-1.202",
      "metrics-js": "static-1.8857",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4557",
      "jasmine": "static-4.3446",
      "PortalIdParser": "static-2.297",
      "quartz-core-utils": "static-1.2725",
      "StyleGuideUI": "static-3.470",
      "quartz-core": "static-1.5077",
      "csstype": "static-1.38",
      "bend-plugin-foundations-components": "static-1.2738",
      "floating-ui": "static-1.32",
      "foundations-assets": "static-1.3998",
      "foundations-theming": "static-1.3404",
      "foundations-theming-specialty": "static-1.1121",
      "hs-story-utils": "static-1.8461",
      "react-aria": "static-1.42",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.77",
      "styled-components": "static-2.64",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.333",
      "ui-images": "static-2.909",
      "hoist-non-react-statics": "static-3.9",
      "copilot-toolkit": "static-1.8007",
      "dispatcher": "static-1.117",
      "general-store": "static-6.20",
      "HeadJS": "static-2.595",
      "history": "static-4.47",
      "hs-promise-rejection-tracking": "static-1.4618",
      "hub-http": "static-1.4807",
      "hub-http-janus": "static-1.667",
      "hub-http-shared-msw-handlers": "static-1.7465",
      "hubspotter-http": "static-1.3820",
      "hubspotter-http-shared-msw-handlers": "static-1.7463",
      "icons": "static-2.593",
      "mobile-manifest-mixins": "static-1.366",
      "platform-navigation-bootstrap": "static-1.11523",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.5091",
      "raven-hubspot": "static-1.5398",
      "react-rhumb": "static-1.15660",
      "react-router-dom": "static-5.26",
      "UIComponents": "static-3.7563",
      "webpack-env": "static-1.54",
      "bend-plugin-foundations-theming": "static-1.1887",
      "foundations-theming-base": "static-1.2389",
      "react-input-autosize": "static-2.17",
      "classnames": "static-2.10",
      "chatspot-client-types": "static-1.9277",
      "chatspot-core": "static-1.17415",
      "ts-schema": "static-1.3346",
      "sassPrefix": "static-1.136",
      "platform-infra-nav-components": "static-1.6932",
      "cssUtils": "static-1.547",
      "head-dlb": "static-1.4210",
      "HubStyle": "static-2.10924",
      "HubStyleTokens": "static-2.10616",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.4536",
      "hs-test-utils": "/hs-test-utils/static-1.7096",
      "I18n": "/I18n/static-7.1412",
      "jasmine-runner": "/jasmine-runner/static-1.5516",
      "quartz": "/quartz/static-1.5858",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3383",
      "outpost": "/outpost/static-1.3448",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.151",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.6469",
      "framer-motion": "/framer-motion/static-1.44",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2207",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.126",
      "enviro": "/enviro/static-4.319",
      "i18n-data": "/i18n-data/static-1.202",
      "metrics-js": "/metrics-js/static-1.8857",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4557",
      "jasmine": "/jasmine/static-4.3446",
      "PortalIdParser": "/PortalIdParser/static-2.297",
      "quartz-core-utils": "/quartz-core-utils/static-1.2725",
      "StyleGuideUI": "/StyleGuideUI/static-3.470",
      "quartz-core": "/quartz-core/static-1.5077",
      "csstype": "/csstype/static-1.38",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2738",
      "floating-ui": "/floating-ui/static-1.32",
      "foundations-assets": "/foundations-assets/static-1.3998",
      "foundations-theming": "/foundations-theming/static-1.3404",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1121",
      "hs-story-utils": "/hs-story-utils/static-1.8461",
      "react-aria": "/react-aria/static-1.42",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.77",
      "styled-components": "/styled-components/static-2.64",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.333",
      "ui-images": "/ui-images/static-2.909",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "copilot-toolkit": "/copilot-toolkit/static-1.8007",
      "dispatcher": "/dispatcher/static-1.117",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.595",
      "history": "/history/static-4.47",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4618",
      "hub-http": "/hub-http/static-1.4807",
      "hub-http-janus": "/hub-http-janus/static-1.667",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7465",
      "hubspotter-http": "/hubspotter-http/static-1.3820",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7463",
      "icons": "/icons/static-2.593",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.366",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11523",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.5091",
      "raven-hubspot": "/raven-hubspot/static-1.5398",
      "react-rhumb": "/react-rhumb/static-1.15660",
      "react-router-dom": "/react-router-dom/static-5.26",
      "UIComponents": "/UIComponents/static-3.7563",
      "webpack-env": "/webpack-env/static-1.54",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1887",
      "foundations-theming-base": "/foundations-theming-base/static-1.2389",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "classnames": "/classnames/static-2.10",
      "chatspot-client-types": "/chatspot-client-types/static-1.9277",
      "chatspot-core": "/chatspot-core/static-1.17415",
      "ts-schema": "/ts-schema/static-1.3346",
      "sassPrefix": "/sassPrefix/static-1.136",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6932",
      "cssUtils": "/cssUtils/static-1.547",
      "head-dlb": "/head-dlb/static-1.4210",
      "HubStyle": "/HubStyle/static-2.10924",
      "HubStyleTokens": "/HubStyleTokens/static-2.10616",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};